<template>
    <Modal :title="$t('seller.sell.SellModal.AuctionCalculation')"
           :close-on-click-outside="false"
           @close="closeNoticeModal"
    >
        <template v-slot:body>
			<form class="modal-content">
				<div class="form_item text_left">
					<div>{{ $t("seller.sell.SellModal.SalesPriceCalcText") }} <a :href="sellPriceFormulaUrl" target="_blank">
						({{ $t("common.button.showFormula") }}).
					</a></div>
				</div>

				<div class="form_item flex flex_between margin_top">
					<md-radio v-model="form.rateRadio" :value="true"/>
					<md-field :class="[{ 'md-error': errors.has('discountRateInstantBuy') }]"
							  key="field-discountRateInstantBuy">
						<label>{{ $t("seller.sell.SellModal.DiscountRateInstantBuyIn") }}</label>
						<MoneyAmountInput v-model="form.discountRate.instantBuyPercentage"
										  data-vv-name="discountRateInstantBuy"
										  :data-vv-as="$t('seller.sell.SellModal.DiscountRateInstantBuyIn')"
										  v-validate="modelValidations.discountRateInstantBuy"
										  ref="discountRateInstantBuy"
										  v-on:focusStart="onChangeDiscountRateRadio"
						></MoneyAmountInput>
						<span v-if="errors.has('discountRateInstantBuy')"
							  class="validation-error">{{ errors.first("discountRateInstantBuy") }}</span>
					</md-field>
					%
				</div>

				<div class="form_item flex flex_between margin_top">
					<md-radio v-model="form.rateRadio" :value="false"/>
					<md-field :class="[{ 'md-error': errors.has('annualInterestRateInstantBuy') }]"
							  key="field-annualInterestRateInstantBuy">
						<label>{{ $t("seller.sell.SellModal.AnnualInterestRateInstantBuyIn") }}</label>
						<MoneyAmountInput v-model="form.annualInterestRate.instantBuyPercentage"
										  data-vv-name="annualInterestRateInstantBuy"
										  :data-vv-as="$t('seller.sell.SellModal.AnnualInterestRateInstantBuyIn')"
										  v-validate.immediate="modelValidations.annualInterestRateInstantBuy"
										  ref="annualInterestRateInstantBuy"
										  v-on:focusStart="onChangeAnnualInterestRateRadio"
						></MoneyAmountInput>
						<span v-if="errors.has('annualInterestRateInstantBuy')"
							  class="validation-error">{{ errors.first("annualInterestRateInstantBuy") }}</span>
					</md-field>
					%
				</div>
			</form>
            <div class="flex flex_between form_item margin_top">
                <md-button class="md-blank" @click="closeNoticeModal">{{ $t("common.button.cancel") }}</md-button>
                <md-button
                    class="opacity_5"
                    :class="{ 'md-primary': isFormValid }"
                    @click="submit"
                >{{ $t("modal.ModalTem.Calculate") }}
                </md-button>
            </div>
        </template>
    </Modal>
</template>
<script>
import Modal from "@/components/templates/modal/Modal";
import {startPriceCalculator} from "@/components/templates/seller/sell/startPriceCalculator";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";
import {validateForm, validateRequiredFields} from "@/validation/validation";
import {sellPriceFormula} from "@/components/templates/seller/sell/sellPriceFormula";

export default {
    components: {
        MoneyAmountInput,
        Modal
    },
    props: {
        data: { type: Array, default: [] },
    },
    data() {
        return {
            modelValidations: {
                discountRateInstantBuy: {
                    min_value: 0,
                    max_value: 100
                },
                annualInterestRateInstantBuy: {
                    min_value: 0,
                    max_value: 100
                }
            },
            form: {
                discountRate: {
                    instantBuyPercentage: null,
                },
                annualInterestRate: {
                    instantBuyPercentage: null,
                },
				rateRadio: false
            },
            rateType: {
                discount: "discount",
                annualInterest: "annualInterest"
            },
            activeRateType: "",
        };
    },
    beforeMount() {
        this.activeRateType = this.rateType.discount;
    },
    computed: {
        isFormValid() {
            return validateRequiredFields(this.form, this.modelValidations);
        },
	    sellPriceFormulaUrl() {
		    return sellPriceFormula.fileUrlForCurrentLocale();
	    },
    },
    methods: {
        closeNoticeModal() {
            this.$emit("close");
        },
		onChangeDiscountRateRadio() {
			this.activeRateType = this.rateType.discount;
			this.form.annualInterestRate.instantBuyPercentage = "";
			this.form.rateRadio = true;
		},
		onChangeAnnualInterestRateRadio() {
			this.activeRateType = this.rateType.annualInterest;
			this.form.discountRate.instantBuyPercentage = "";
			this.form.rateRadio = false;
		},
        submit() {
            validateForm(this, this.$validator)
                .then(() => {
                    if (this.activeRateType === this.rateType.discount) {
                        this.calculateWithDiscountRate();
                    } else if (this.activeRateType === this.rateType.annualInterest) {
                        this.calculateWithAnnualInterestRate();
                    }

                    this.toastSuccess();
                    this.closeNoticeModal();
                })
                .catch(e => this.toast(e));
        },
        calculateWithDiscountRate() {
            this.data.forEach(data => {
                if (this.form.discountRate.instantBuyPercentage) {
                    data.instantBuyPercentage = this.form.discountRate.instantBuyPercentage;
                }
            });
        },
        calculateWithAnnualInterestRate() {
            let params = {
                considerCreditRisk: this.form.annualInterestRate.considerCreditRisk,
                considerLpds: this.form.annualInterestRate.considerLpds
            };

            this.data.forEach(data => {
                if (this.form.annualInterestRate.instantBuyPercentage) {
                  data.instantBuyPercentage = startPriceCalculator.calculateDiscountPercentageWithInterestRate(data, this.form.annualInterestRate.instantBuyPercentage, params);
                }
            });
        }
    },
};
</script>
<style lang="scss" scoped>

.form_item {
    padding: 0 10px;
}

.btn_title {
    margin: 2rem 0;
}

</style>
